import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function ScenariosSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 text-accent-700 text-sm font-medium mb-4">
            应用场景
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            覆盖多行业多场景，满足你的所有需求
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto leading-relaxed">
            无论你是想搭建内部管理系统、构建客户应用，还是推动企业数字化转型，无码都能帮你快速落地。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
          {categories.map((cat) => {
            const catArticles = articles.filter((a) => a.category === cat.slug);
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group p-7 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600 mb-5 group-hover:bg-accent-100 transition-colors">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{cat.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{cat.articleCount} 篇文章</span>
                  <span className="text-primary-600 text-sm font-medium flex items-center gap-1 group-hover:gap-2 transition-all whitespace-nowrap">
                    了解更多
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center">
          <p className="text-sm text-foreground-500 mb-6">精选内容抢先看</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {articles.slice(0, 3).map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group text-left p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {categories.find((c) => c.slug === article.category)?.name}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h4 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.summary}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}